/**
 * Entry point del UI kit.
 * Auto-registra todos los componentes + la API imperativa window.ExtUI al cargar el bundle.
 */
import './tokens.css';
import './registry';

// Auto-registro de componentes (custom elements se definen via @customElement).
import '../components/ext-hello/ext-hello';
import '../components/ext-icon/ext-icon';
import '../components/ext-spinner/ext-spinner';
import '../components/ext-button/ext-button';
import '../components/ext-chip/ext-chip';
import '../components/ext-card/ext-card';
import '../components/ext-toast/ext-toast';
import '../components/ext-input/ext-input';
import '../components/ext-textarea/ext-textarea';
import '../components/ext-select/ext-select';
import '../components/ext-autocomplete/ext-autocomplete';
import '../components/ext-modal/ext-modal';
import '../components/ext-table/ext-table';
import '../components/ext-tabs/ext-tabs';
import '../components/ext-fader/ext-fader';

// Registra la API imperativa real (overrides los stubs del registry).
import { registerToastService } from '../components/ext-toast/toast-service';
registerToastService();

export { ExtBaseElement } from './ExtBaseElement';
export type { ToastOptions, ExtUIRegistry } from './registry';

// TODO(UI-MONO-2): remover una vez validado el import map sharing con @extranet/cash.
// Expone la LitElement resuelta por ui-kit.js para poder comparar en runtime:
//   window.ExtUI._debug.LitElement === (LitElement de otro workspace)
// Si la igualdad estricta vale, el import map esta deduplicando Lit como se espera.
import { LitElement } from 'lit';
if (typeof window !== 'undefined') {
  const w = window as unknown as { ExtUI?: Record<string, unknown> };
  w.ExtUI = w.ExtUI ?? {};
  (w.ExtUI as Record<string, unknown>)._debug = {
    litSource: 'ui-kit',
    LitElement,
  };
}
